// extracted by mini-css-extract-plugin
module.exports = {"header":"_1jPjZr","closeButton":"_2oFZnA","totalCount":"_1DU7f-"};